export default __webpack_public_path__ + "static/media/negotiating.fefcbcb5.svg";